import api from "@/core/api";

export const beforeSave = (data: any) => api.query(`/patients/beforesave`, { method: "post", data });
export const thereAreStudies = (patient: string) => api.query(`/patients/therearestudies/${patient}`, { method: "get" });
